import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import styles from './ProductCardRating.module.scss';
type ProductCardRatingProps = {
  reviews: number;
  rank: number;
};
const ProductCardRating: FC<ProductCardRatingProps> = ({
  rank,
  reviews
}) => {
  return <Box className={styles['rating_section']} data-name={'card_rate_details'} data-sentry-element="Box" data-sentry-component="ProductCardRating" data-sentry-source-file="ProductCardRating.tsx">
      <Box className={styles['rating_description']} data-sentry-element="Box" data-sentry-source-file="ProductCardRating.tsx">
        <Icon name="star-filled" type="primary" size={'small'} data-sentry-element="Icon" data-sentry-source-file="ProductCardRating.tsx" />
        <Box className={styles['rating_content']} data-sentry-element="Box" data-sentry-source-file="ProductCardRating.tsx">
          {reviews > 0 && rank > 0 ? <>
              <Typography variant="bodyM">
                {rank?.toFixed(1)?.includes('0') ? Math.round(rank) : rank?.toFixed(1)}
              </Typography>
              <Typography variant="bodyS" className={styles.review_rank_text}>{`(${reviews} نظر)`}</Typography>
            </> : <Typography variant="bodyS" className={styles.review_rank_text}>
              اقامتگاه‌ جدید
            </Typography>}
        </Box>
      </Box>
    </Box>;
};
export default ProductCardRating;